export default __webpack_public_path__ + "static/media/all_feedback.c61b38cb.png";